import { getBaseUrl, request } from 'src/helper/api';

export const fetchMarkets = (token?: string, signal?: AbortSignal) =>
  request(
    { method: 'GET', url: `${getBaseUrl()}api/markets`, token, signal },
    'markets/fetchMarkets',
  );

export const createMarket = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/market/actions/createMarket`,
      contentType: 'json',
      token,
      signal,
      shouldAddSocketId: true,
    },
    'markets/createMarket',
  );

export const updateMarket = (market_id: string, token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'PUT',
      url: `${getBaseUrl()}api/market/${market_id}/actions/updateMarket`,
      contentType: 'json',
      token,
      signal,
    },
    'markets/updateMarket',
  );

export const fetchAssignedZips = (token?: string, signal?: AbortSignal) =>
  request(
    { method: 'GET', url: `${getBaseUrl()}api/markets/blocked-zipcodes`, token, signal },
    'markets/fetchAssignedZips',
  );

export const fetchMarket = (market_id: string, token?: string, signal?: AbortSignal) =>
  request(
    { method: 'GET', url: `${getBaseUrl()}api/markets/${market_id}`, token, signal },
    'markets/fetchMarket',
  );

// Read-only pre-flight check: returns the impact of deleting a market
// (affected properties / open service requests). Does NOT delete anything,
// so it must not touch the `isMarketDeleting` state or remove the market.
export const validateDeleteMarket = (market_id: string, token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'DELETE',
      url: `${getBaseUrl()}api/market/${market_id}/actions/deleteMarket?should_validate=true`,
      token,
      signal,
      shouldAddSocketId: true,
    },
    'markets/validateDeleteMarket',
  );

// Actual destructive delete. Only this thunk drives `isMarketDeleting` and
// removes the market from state on success.
export const deleteMarket = (market_id: string, token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'DELETE',
      url: `${getBaseUrl()}api/market/${market_id}/actions/deleteMarket`,
      token,
      signal,
      shouldAddSocketId: true,
    },
    'markets/deleteMarket',
  );
